import { AxiosInstance } from "axios";
import { UserToEventBundleDto, EventBundleWithStatsDto, UserEventBundleFilter } from '@sweatpals/shared';

export class EventBundlesService {
	private readonly basePath = 'event-bundles';

	constructor(private readonly httpClient: AxiosInstance) {}

	public async getUserEventBundles(filter: UserEventBundleFilter): Promise<UserToEventBundleDto[]> {
		const { data } = await this.httpClient.get<UserToEventBundleDto[]>(`${this.basePath}/user`, { params: filter });

		return data;
	}

	public async getPublishedEventBundlesByCommunityId(communityId: string): Promise<EventBundleWithStatsDto[]> {
		const { data } = await this.httpClient.get<EventBundleWithStatsDto[]>(`${this.basePath}/public/community/${communityId}`);
		return data;
	}

	public async getPublishedEventBundleById(eventBundleId: string): Promise<EventBundleWithStatsDto> {
		const { data } = await this.httpClient.get<EventBundleWithStatsDto>(`${this.basePath}/public/${eventBundleId}`);

		return data;
	}

	public async getPublishedEventBundlesByEventId(eventId: string): Promise<EventBundleWithStatsDto[]> {
		const { data } = await this.httpClient.get<EventBundleWithStatsDto[]>(`${this.basePath}/public/event/${eventId}`);

		return data;
	}
}
